import tableRelatedAppTags from './tableRelatedAppTags';

export default {
  title: 'Available tags',
  attributeName: 'appTags',
  getURL: 'appId/appTagsPlay',
  createURL: '',
  updateURL: '',
  removeURL: '',
  itemName: 'name',
  itemId: 'id',
  sessionParams: ['appId'],
  tableConfig: tableRelatedAppTags
};
